import { takeLatest, put, select } from 'redux-saga/effects';
import { resetPersistence } from '@store/persistentConfig/actions';
import {isAppModule, NOC_MODE_TRENDS} from '@utils/constants';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import {
  nocModeSelector, filtersViewSelector, trendsViewSelector,
} from '@store/noc/base/selectors';
import {
  setTempIdToFilters,
} from '@store/noc/base/reducer';
// import { triggerUpdateTab } from '@store/dashboards/tabs/actions';
import { updateDashboardById } from '@store/dashboards/update/actions';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { nocUrlSelector } from './selectors';
import * as actions from './actions';
import * as types from './types';
import {
  // eslint-disable-next-line max-len
  closeNocDrawer, openNocDrawer, setInitialFiltersToDrawer, setInitialTrendsFilterToDrawer, setNocUrl,
  resetTrendsDrawer, resetFiltersDrawer,
} from './actions';
import { applyTrendsSelectedNocFilters, applyFiltersSelectedNocFilters } from '../base/actions';

const { baseUrl } = window.conviva;

function* initRequest() {
  yield put(actions.init());
}

function* navigateToRT(action) {
  const { history, filters, type } = action.params;
  const nocUrl = yield select(nocUrlSelector);

  yield put(closeNocDrawer());
  if (nocUrl.type === 'saved') {
    const arr = nocUrl.url.split('/');
    // eslint-disable-next-line radix
    const dashboards = yield select(dashboardsSelector);
    const currentShareId = Number(arr[arr.length - 1]);
    const tempDashboardId = `saved-${currentShareId}`;
    const tempDashboard = dashboards[tempDashboardId];
    const { dashboard } = tempDashboard;
    if (type === NOC_MODE_TRENDS) {
      dashboard.base.trends.appliedFilter = setTempIdToFilters([filters]);
    } else {
      dashboard.base.filters.appliedFilter = setTempIdToFilters(filters);
    }
    yield put(updateDashboardById(currentShareId, tempDashboard.title, dashboard, false));
  } else if (nocUrl.type === 'shared') {
    // WIP
    const arr = nocUrl.url.split('/');
    const tabsSelectors = yield select(tabsStoreSelector);
    const currentShareId = arr[arr.length - 1];
    const newState = tabsSelectors.tabsData[currentShareId];
    let data = null;
    if (newState.config.base) {
      data = newState.config.base;
    } else {
      data = newState.config.nocStore;
    }
    if (type === NOC_MODE_TRENDS) {
      data.trends.appliedFilter = setTempIdToFilters([filters]);
    } else {
      data.filters.appliedFilter = setTempIdToFilters(filters);
    }
    tabsSelectors.tabsData[currentShareId].config = data;
  } else {
    yield put(resetPersistence({ skipGetAction: true }));
    if (type === NOC_MODE_TRENDS) {
      yield put(applyTrendsSelectedNocFilters([filters]));
    } else {
      yield put(applyFiltersSelectedNocFilters(filters));
    }
  }
  history.push(`${nocUrl.url}`);
}

function* navigateToTrends(action) {
  const { history } = action.params;
  const { location: { pathname } } = history;
  const mode = yield select(nocModeSelector);
  // eslint-disable-next-line no-nested-ternary
  const type = pathname?.includes('real-time/sharing') ? 'shared' : pathname?.match(/real-time\/[0-9]/) ? 'saved' : 'noc';
  yield put(setNocUrl({
    url: pathname,
    type,
  }));
  // direct to trends
  history.push(`${baseUrl}/dashboard/${isAppModule ? 'app-experience' : 'trends'}/modify-real-time`);
  yield put(openNocDrawer());
  if (mode === NOC_MODE_TRENDS) {
    yield put(resetTrendsDrawer());
    const filters = yield select(trendsViewSelector);
    yield put(setInitialTrendsFilterToDrawer(filters));
  } else {
    yield put(resetFiltersDrawer());
    const filters = yield select(filtersViewSelector);
    yield put(setInitialFiltersToDrawer(filters));
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchNavigateToRT() {
  yield takeLatest([
    types.NAVIGATE_TO_RT,
  ], navigateToRT);
}

function* watchNavigateToTrends() {
  yield takeLatest([
    types.NAVIGATE_TO_TRENDS,
  ], navigateToTrends);
}

export default [
  watchInitRequest,
  watchNavigateToRT,
  watchNavigateToTrends,
];
